export function resolveWorkspaceMemberLabel(
  displayName: string | null | undefined,
  fullName: string | null | undefined,
): string {
  const name = (displayName || fullName || "").trim();
  return name || "Membro da equipe";
}
